'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdWc = function MdWc(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm27.5 10c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.2 3.4-3.2 3.4 1.4 3.4 3.2-1.5 3.4-3.4 3.4z m-15 0c-1.9 0-3.4-1.5-3.4-3.4s1.5-3.2 3.4-3.2 3.4 1.4 3.4 3.2-1.5 3.4-3.4 3.4z m17.5 26.6h-5v-10h-5l4.2-12.6c0.5-1.3 1.8-2.4 3.2-2.4h0.2c1.4 0 2.7 1.1 3.2 2.4l4.2 12.6h-5v10z m-20.9 0v-12.5h-2.5v-9.1c0-1.8 1.6-3.4 3.4-3.4h5c1.8 0 3.4 1.6 3.4 3.4v9.1h-2.5v12.5h-6.8z' })
        )
    );
};

exports.default = MdWc;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/wc.js
// module id = 1353
// module chunks = 0